<div class="p-fluid">
  <div class="p-grid">
    <div class="p-col-12 p-lg-2">
      <label [for]="fonteDadosProxy">Rota:</label>
    </div>
    <div class="p-col-12 p-lg-10">
      <p-dropdown placeholder="Selecione..."
      [options]="rotasItens"
      [showClear]="true"
      optionLabel="label"
      optionValue="value"
      filter="true"
      [(ngModel)]="fonteDadosProxy"
      (ngModelChange)="selecionarRota($event)" >
      </p-dropdown>
    </div>
  </div>

  <div *ngIf="fonteDadosProxy && fonteDadosProxy.parametros">
    <div class="p-grid" *ngFor="let param of fonteDadosProxy.parametros">
      <div class="p-col-12 p-lg-2">
        <label [for]="param.nome" [ngClass]="param.obrigatorio ? 'required':''">{{param.rotulo}}:</label>
      </div>
      <div class="p-col-12 p-lg-4">
        <input *ngIf="param.tipo === parametroProxyTipo.TEXTO" [pTooltip]="param.titulo"
               pInputText
               type="text" [name]="param.nome"
               [(ngModel)]="param.valor"
               (blur)="salvarParametrosSessao(param.key(), $event.target.value)"/>
        <p-inputSwitch *ngIf="param.tipo === parametroProxyTipo.BOOLEAN"
                       [pTooltip]="param.titulo"
                       [(ngModel)]="param.valor"
                       (ngModelChange)="salvarParametrosSessao(param.key(), $event)"
                       class="switch-p"></p-inputSwitch>
        <ng-template [ngIf]="param.tipo === parametroProxyTipo.CHIPS">
          <p-chips [pTooltip]="param.titulo"
                   [(ngModel)]="param.valor"
                   addOnBlur="true"
                   separator=","
                   (ngModelChange)="salvarParametrosSessao(param.key(), $event)">
          </p-chips>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="p-grid">
    <div class="p-col-12 p-lg-6">
      <button pButton (click)="buscar()" label="Buscar"></button>
    </div>
    <div class="p-col-12 p-lg-6">
      <button pButton (click)="limpar()" label="Limpar"></button>
    </div>
  </div>

  <fieldset style="margin-top: 1em" *ngIf="resultado">
    <legend>Resultado:</legend>
    <div class="p-col-12 p-lg-12">
      <ng-template [ngIf]="resultado.tipo === 'json'">
        <ngx-json-viewer [json]="resultado.conteudo" [expanded]="false"></ngx-json-viewer>
      </ng-template>
      <ng-template [ngIf]="resultado.tipo === 'blob'">
        <a [href]="resultado.url">Download do Arquivo</a>
      </ng-template>
    </div>
  </fieldset>
</div>
